export const UPDATE_AVATAR = 'update_avatar';
export const UPDATE_PROFILE = 'update_profile';
